import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import ModuleList from '../../../layout/ModuleList';
import {
  clearExchangeRates,
  getExchangeRates,
} from '../../../../actions/accounting/ExchangeRate';
import { EXCHANGE_RATE_PATH, NEW_EXCHANGE_RATE_PATH } from '../../../../config/paths';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { EXCHANGE_RATE_COLUMNS } from '../../../../config/columns';

export const ExchangeRates = ({
  breadcrumbs,
  exchangeRates,
  loading,
  dispatchGetExchangeRates,
  dispatchClearExchangeRates,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearExchangeRates();
    },
    [],
  );

  const data = exchangeRates.get('content') || [];
  const pages = exchangeRates.get('totalPages') || null;
  const defaultPageSize = exchangeRates.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Tasas de Cambios"
      buttonPath={NEW_EXCHANGE_RATE_PATH}
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns: EXCHANGE_RATE_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetExchangeRates,
        loading,
        modelPath: EXCHANGE_RATE_PATH,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetExchangeRates: getExchangeRates,
  dispatchClearExchangeRates: clearExchangeRates,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tasas de Cambio',
      href: EXCHANGE_RATE_PATH,
    },
  ],
  exchangeRates: AccountingUnit.ExchangeRate.getIn(['all', 'content']),
  loading: AccountingUnit.ExchangeRate.getIn(['all', 'loading']),
});

ExchangeRates.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  exchangeRates: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetExchangeRates: PropTypes.func.isRequired,
  dispatchClearExchangeRates: PropTypes.func.isRequired,
};

ExchangeRates.defaultProps = {
  exchangeRates: [],
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeRates);
